import axios from 'axios';
import { debugLog } from './logger';

// ── Axios instance pointed at patient-pref-service ──────────────────────────
const api = axios.create({
    baseURL        : import.meta.env.VITE_API_BASE_URL,
    timeout        : 15000,
    headers        : { 'Content-Type': 'application/json' },
    withCredentials: false
});

// ── Request interceptor — attach session token if present ───────────────────
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('surveySessionToken');
    debugLog('ui_api_request_started', {
        method  : config.method,
        url     : config.url,
        hasToken: Boolean(token)
    });
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
});

// ── Response interceptor — normalise errors ─────────────────────────────────
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status  = error.response?.status;
        const code    = error.response?.data?.code    || 'NETWORK_ERROR';
        const message = error.response?.data?.message || 'An unexpected error occurred. Please try again.';
        const attemptsRemaining = error.response?.data?.attemptsRemaining;
        const maxAttempts       = error.response?.data?.maxAttempts;

        debugLog('ui_api_request_failed', {
            method  : error.config?.method,
            url     : error.config?.url,
            status,
            code
        });

        // Session expired — clear storage but let the caller handle redirect
        if (status === 401) {
            sessionStorage.removeItem('surveySessionToken');
            sessionStorage.removeItem('surveyPatient');
        }

        return Promise.reject({ status, code, message, attemptsRemaining, maxAttempts });
    }
);

export default api;
